import { render, staticRenderFns } from "./RError.vue?vue&type=template&id=a33cfb26&scoped=true"
import script from "./RError.vue?vue&type=script&lang=js"
export * from "./RError.vue?vue&type=script&lang=js"
import style0 from "./RError.vue?vue&type=style&index=0&id=a33cfb26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33cfb26",
  null
  
)

export default component.exports